<template>
	<div class="page auth">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M5.5,5.5A5.5,5.5,0,1,1,11,11,5.5,5.5,0,0,1,5.5,5.5ZM0,22V19.25c0-3,5-5.5,11-5.5s11,2.48,11,5.5V22Z"/></svg>
					<span class="navigation-title">{{$t('login')}}</span>
				</div>
			</div>
		</section>
		<section class="main">
			<transition name="slide-up" mode="out-in" appear>
				<div class="page">
					<form @submit.prevent="login" ref="form">
						<div class="field">
							<div class="container">
								<div class="content">
									<div class="field-inner">
										<label for="username">{{$t('username')}}</label>
										<div class="element">
											<input type="text" placeholder=" " v-model="username" id="username" required>
										</div>
										<label for="password">{{$t('password')}}</label>
										<div class="element">
											<input type="password" placeholder=" " v-model="password" id="password" required>
										</div>
										<div class="element">
											<label for="remember-me"><input type="checkbox" id="remember-me" v-model="rememberMe">{{$t('remember-me')}}</label>
										</div>
										<div class="element">
											<a href="">{{$t('forgot-password-?')}}</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<hr>
						<div class="container">
							<div class="content">
								<button>{{$t('enter')}}</button>
							</div>
						</div>
					</form>
					<!-- <p>{{$t('reserved-area-message')}}</p> -->
				</div>
			</transition>
		</section>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Login',
	data() {
		return {
			username: '',
			password: '',
			rememberMe: false,
			loginError: false,
		}
	},
	mounted() {
		if (this.$store.getters.isAuthenticated) {
			this.$router.push({name: 'home'});
		}
	},
	methods: {
		login () {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			this.loginError = false;

			const data = {
				username: this.username,
				password: this.password,
				rememberMe: this.rememberMe
			};

			var self = this;
			this.$store.dispatch('authRequest', data)
			.then(() => {
				self.$snack.success(self.$t('connected'));
				self.$router.push(self.$route.query.redirect || {name: 'home'});
			})
			.catch(() => {
				self.loginError = true;
				self.$snack.danger(self.$t('authentication-error'));
				if (navigator.vibrate){
					navigator.vibrate([500]);
				}
			});
		}
	}
}
</script>